export const ru = {
    'request-error': 'Произошла непредвиденная ошибка.'
};
